import { useTranslation } from 'react-i18next'
import { HeroPage } from '@/components/HeroPage'
import { SkillsGrid } from '@/components/sections/SkillsGrid'
import { ContactCTA } from '@/components/sections/ContactCTA'

export function Skills() {
  const { t } = useTranslation()

  return (
    <main>
      <HeroPage
        title={t('skills.hero.title')}
        subtitle={t('skills.hero.subtitle')}
        backgroundImage="/images/general/blog_header.png"
        breadcrumb={[{ label: t('nav.skills') }]}
      />
      <SkillsGrid />
      <ContactCTA />
    </main>
  )
}
